import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const Sidebar = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const menuItems = [
    {
      title: "COURT FORMS",
      items: [
        { text: "First Circuit", url: "https://www.courts.state.hi.us/self-help/courts/forms/oahu/oahu_first_circuit_forms" },
        { text: "Second Circuit", url: "https://www.courts.state.hi.us/self-help/courts/forms/maui/maui_second_circuit_forms" },
        { text: "Third Circuit", url: "https://www.courts.state.hi.us/self-help/courts/forms/hawaii/hawaii_third_circuit_forms" },
        { text: "Fifth Circuit", url: "https://www.courts.state.hi.us/self-help/courts/forms/kauai/kauai_fifth_circuit_forms" },
        { text: "Statewide Forms", url: "https://www.courts.state.hi.us/self-help/courts/forms/court_forms" }
      ]
    },
    {
      title: "COURT LOCATIONS AND PHONE NUMBERS",
      items: [
        { text: "First Circuit", url: "https://www.courts.state.hi.us/general_information/contact/oahu" },
        { text: "Second Circuit", url: "https://www.courts.state.hi.us/general_information/contact/maui" },
        { text: "Third Circuit", url: "https://www.courts.state.hi.us/general_information/contact/hawaii" },
        { text: "Fifth Circuit", url: "https://www.courts.state.hi.us/general_information/contact/kauai" }
      ]
    },
    {
      title: "eCOURT KOKUA/CASE LOOKUP",
      url: "https://www.courts.state.hi.us/legal_references/records/jims_system_availability"
    },
    {
      title: "eREMINDER FOR COURT DATES",
      url: "https://www.courts.state.hi.us/ereminder",
      items: [
        { text: "Register", url: "http://jimspss1.courts.state.hi.us:8080/eReminderExternal/login.jspx" }
      ]
    },
    {
      title: "JEFS/e-FILING",
      url: "https://www.courts.state.hi.us/legal_references/efiling",
      items: [
        { text: "JEFS Login", url: "https://jimspss1.courts.state.hi.us/JIMSExternal/login.iface" },
        { text: "JEFS Login and Self-Registration Information", url: "https://www.courts.state.hi.us/wp-content/uploads/2017/01/JEFS_Login_and_Self_Registration.pdf" },
        { text: "JEFS Guide for Subscribers", url: "https://www.courts.state.hi.us/wp-content/uploads/2021/01/Guide-to-Document-Subscribers.pdf" },
        { text: "JEFS Self-Represented Litigants Guide", url: "https://www.courts.state.hi.us/wp-content/uploads/2023/03/JEFS-SRL-Guide-3-2023-ADA.pdf" }
      ]
    },
    {
      title: "JURY DUTY SERVICE",
      items: [
        { text: "Jury Duty FAQs", url: "https://www.courts.state.hi.us/general_information/jury/jury_service_faqs#one" },
        { text: "Do I have Jury Duty?", url: "https://www.courts.state.hi.us/general_information/jury/jury_prelogin" }
      ]
    },
    {
      title: "PAY FOR TRAFFIC FINE",
      url: "https://www.courts.state.hi.us/self-help/traffic/the_etraffic_hawaii_website"
    },
    {
      title: "REMOTE HEARINGS (ZOOM) INFORMATION",
      url: "https://www.courts.state.hi.us/remote-court-hearings-via-zoom-or-webex",
      items: [
        { text: "First Circuit Court Zoom Numbers", url: "https://www.courts.state.hi.us/wp-content/uploads/2022/10/1DC_Zoom_flyer_with_civil.pdf" },
        { text: "Second Circuit Court Zoom Numbers", url: "https://www.courts.state.hi.us/wp-content/uploads/2024/07/2024-22-07-Second-Circuit-Remote-Hearings.revised-071524-1.pdf" },
        { text: "Third Circuit Court Zoom Numbers", url: "https://www.courts.state.hi.us/wp-content/uploads/2021/05/Third-Circuit-Zoom-ID-Meeting-Numbers.pdf" },
        { text: "Do's and Don'ts of Remote Hearings", url: "https://www.youtube.com/embed/VLD-kWLfjq4" }
      ]
    },
    {
      title: "REQUEST A COURT INTERPRETER",
      url: "https://www.courts.state.hi.us/services/how_to_request_an_interpreter_for_court_proceeding"
    },
    {
      title: "SELF HELP CENTERS",
      url: "https://www.courts.state.hi.us/general_information/access_to_justice_rooms_self_help_centers"
    }
  ];

  return (
    <div className="w-80 bg-white border-r border-gray-200 overflow-y-auto h-screen fixed left-0 font-['Montserrat']">
      <div className="p-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-6 text-left">Quick Links</h2>
        <div className="space-y-1 text-left">
          {menuItems.map((section, index) => (
            <div key={index} className="border-b border-gray-100 last:border-0">
              <div 
                className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50 rounded-md transition-colors px-2 text-left"
                onClick={() => section.items && toggleSection(section.title)}
              >
                <div className="flex items-center gap-2 text-left">
                  {section.items ? (
                    expandedSections[section.title] ? 
                      <ChevronDown className="w-4 h-4 text-gray-500 flex-shrink-0" /> : 
                      <ChevronRight className="w-4 h-4 text-gray-500 flex-shrink-0" />
                  ) : <div className="w-4" />}
                  {section.url ? (
                    <a 
                      href={section.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline text-sm font-medium text-left"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {section.title}
                    </a>
                  ) : (
                    <span className="text-sm font-medium text-gray-700 text-left">{section.title}</span>
                  )}
                </div>
              </div>
              {section.items && expandedSections[section.title] && (
                <div className="ml-6 pb-2 pt-1 text-left">
                  {section.items.map((item, itemIndex) => (
                    <a
                      key={itemIndex}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block py-2 px-3 text-sm text-blue-500 hover:bg-blue-50 rounded-md mb-1 transition-colors text-left"
                    >
                      {item.text}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;